var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// src/constants/world.ts
var TILE_W = 64;
var TILE_H = 32;
var WORLD_W = 96;
var WORLD_H = 96;
var BUILD_RANGE = 4;
var TICK_RATE = 20;
var TICK_MS = 1e3 / TICK_RATE;
var PLAYER_SPEED = 4.2;
var AOI_RADIUS = 18;
var DAY_LENGTH_SEC = 600;
var NIGHT_START = 0.72;
var NIGHT_END = 0.96;
var Biome = /* @__PURE__ */ ((Biome2) => {
  Biome2["Greenwood"] = "greenwood";
  Biome2["Highland"] = "highland";
  Biome2["Hollow"] = "hollow";
  return Biome2;
})(Biome || {});
var BIOMES = {
  ["greenwood" /* Greenwood */]: { id: "greenwood" /* Greenwood */, name: "Greenwood", tint: 5214026, danger: 1 },
  ["highland" /* Highland */]: { id: "highland" /* Highland */, name: "Stonereach Highland", tint: 9080183, danger: 1.2 },
  ["hollow" /* Hollow */]: { id: "hollow" /* Hollow */, name: "Dusk Hollow", tint: 3814736, danger: 1.8 }
};
function hash2(x, y) {
  const h = Math.sin(x * 127.1 + y * 311.7) * 43758.5453;
  return h - Math.floor(h);
}
function valueNoise(x, y) {
  const xi = Math.floor(x);
  const yi = Math.floor(y);
  const xf = x - xi;
  const yf = y - yi;
  const tl = hash2(xi, yi);
  const tr = hash2(xi + 1, yi);
  const bl = hash2(xi, yi + 1);
  const br = hash2(xi + 1, yi + 1);
  const sx = xf * xf * (3 - 2 * xf);
  const sy = yf * yf * (3 - 2 * yf);
  const top = tl + (tr - tl) * sx;
  const bot = bl + (br - bl) * sx;
  return top + (bot - top) * sy;
}
function biomeAt(tx, ty) {
  const n = valueNoise(tx / 14, ty / 14) * 0.65 + valueNoise(tx / 5, ty / 5) * 0.35;
  if (n < 0.4) return "hollow" /* Hollow */;
  if (n < 0.62) return "highland" /* Highland */;
  return "greenwood" /* Greenwood */;
}
function isNight(timeOfDay) {
  return timeOfDay >= NIGHT_START && timeOfDay < NIGHT_END;
}
function darkness(timeOfDay) {
  const mid = (NIGHT_START + NIGHT_END) / 2;
  const half = (NIGHT_END - NIGHT_START) / 2;
  const d = 1 - Math.min(1, Math.abs(timeOfDay - mid) / (half * 1.6));
  return Math.max(0, d);
}

// src/constants/items.ts
var ItemId = /* @__PURE__ */ ((ItemId2) => {
  ItemId2["Wood"] = "wood";
  ItemId2["Stone"] = "stone";
  ItemId2["Fiber"] = "fiber";
  ItemId2["Berry"] = "berry";
  ItemId2["RawMeat"] = "raw_meat";
  ItemId2["CookedMeat"] = "cooked_meat";
  ItemId2["Axe"] = "axe";
  ItemId2["Pickaxe"] = "pickaxe";
  ItemId2["Torch"] = "torch";
  ItemId2["Bow"] = "bow";
  ItemId2["Arrow"] = "arrow";
  ItemId2["IronOre"] = "iron_ore";
  ItemId2["IronIngot"] = "iron_ingot";
  ItemId2["IronAxe"] = "iron_axe";
  ItemId2["IronPickaxe"] = "iron_pickaxe";
  ItemId2["IronSword"] = "iron_sword";
  ItemId2["IronArmor"] = "iron_armor";
  return ItemId2;
})(ItemId || {});
var ITEMS = {
  ["wood" /* Wood */]: { id: "wood" /* Wood */, name: "Wood", category: "material", stack: 99, icon: "\u{1FAB5}" },
  ["stone" /* Stone */]: { id: "stone" /* Stone */, name: "Stone", category: "material", stack: 99, icon: "\u{1FAA8}" },
  ["fiber" /* Fiber */]: { id: "fiber" /* Fiber */, name: "Fiber", category: "material", stack: 99, icon: "\u{1F33E}" },
  ["berry" /* Berry */]: { id: "berry" /* Berry */, name: "Sunberry", category: "food", stack: 99, food: 8, icon: "\u{1FAD0}" },
  ["raw_meat" /* RawMeat */]: { id: "raw_meat" /* RawMeat */, name: "Raw Meat", category: "food", stack: 99, food: 6, icon: "\u{1F969}" },
  ["cooked_meat" /* CookedMeat */]: { id: "cooked_meat" /* CookedMeat */, name: "Cooked Meat", category: "food", stack: 99, food: 22, icon: "\u{1F356}" },
  ["axe" /* Axe */]: { id: "axe" /* Axe */, name: "Hatchet", category: "tool", stack: 1, toolPower: 1, toolFor: "chop", icon: "\u{1FA93}" },
  ["pickaxe" /* Pickaxe */]: { id: "pickaxe" /* Pickaxe */, name: "Pickaxe", category: "tool", stack: 1, toolPower: 1, toolFor: "mine", icon: "\u26CF\uFE0F" },
  ["torch" /* Torch */]: { id: "torch" /* Torch */, name: "Torch", category: "tool", stack: 5, icon: "\u{1F526}" },
  ["bow" /* Bow */]: { id: "bow" /* Bow */, name: "Hunting Bow", category: "ranged", stack: 1, rangedDamage: 7, range: 6, icon: "\u{1F3F9}" },
  ["arrow" /* Arrow */]: { id: "arrow" /* Arrow */, name: "Arrows", category: "material", stack: 99, icon: "\u{1FAB6}" },
  ["iron_ore" /* IronOre */]: { id: "iron_ore" /* IronOre */, name: "Iron Ore", category: "material", stack: 99, icon: "\u{1F7E4}" },
  ["iron_ingot" /* IronIngot */]: { id: "iron_ingot" /* IronIngot */, name: "Iron Ingot", category: "material", stack: 99, icon: "\u{1F529}" },
  ["iron_axe" /* IronAxe */]: { id: "iron_axe" /* IronAxe */, name: "Iron Hatchet", category: "tool", stack: 1, toolPower: 2, toolFor: "chop", icon: "\u{1FA93}" },
  ["iron_pickaxe" /* IronPickaxe */]: { id: "iron_pickaxe" /* IronPickaxe */, name: "Iron Pickaxe", category: "tool", stack: 1, toolPower: 2, toolFor: "mine", icon: "\u26CF\uFE0F" },
  ["iron_sword" /* IronSword */]: { id: "iron_sword" /* IronSword */, name: "Iron Sword", category: "weapon", stack: 1, damage: 8, icon: "\u{1F5E1}\uFE0F" },
  ["iron_armor" /* IronArmor */]: { id: "iron_armor" /* IronArmor */, name: "Iron Armor", category: "armor", stack: 1, defense: 0.4, icon: "\u{1F6E1}\uFE0F" }
};
function toolPowerFor(items, action) {
  let best = 0;
  for (const s of items) {
    const def = ITEMS[s.item];
    if (def?.toolFor === action) best = Math.max(best, def.toolPower ?? 1);
  }
  return best;
}
function bestWeaponDamage(items) {
  let best = 0;
  for (const s of items) {
    const def = ITEMS[s.item];
    if (def?.category === "weapon") best = Math.max(best, def.damage ?? 0);
  }
  return best;
}
function bestRanged(items) {
  let best = null;
  for (const s of items) {
    const def = ITEMS[s.item];
    if (def?.category === "ranged" && (!best || (def.rangedDamage ?? 0) > best.damage))
      best = { damage: def.rangedDamage ?? 0, range: def.range ?? 5 };
  }
  return best;
}
function bestArmorDefense(items) {
  let best = 0;
  for (const s of items) {
    const def = ITEMS[s.item];
    if (def?.category === "armor") best = Math.max(best, def.defense ?? 0);
  }
  return best;
}
function ownsEqualOrBetter(items, itemId) {
  const def = ITEMS[itemId];
  if (!def) return false;
  if (def.category === "tool")
    return def.toolFor ? toolPowerFor(items, def.toolFor) >= (def.toolPower ?? 1) : false;
  if (def.category === "weapon") return bestWeaponDamage(items) >= (def.damage ?? 0);
  if (def.category === "ranged") return (bestRanged(items)?.damage ?? 0) >= (def.rangedDamage ?? 0);
  if (def.category === "armor") return bestArmorDefense(items) >= (def.defense ?? 0);
  return false;
}

// src/constants/structures.ts
var StructureKind = /* @__PURE__ */ ((StructureKind2) => {
  StructureKind2["Campfire"] = "campfire";
  StructureKind2["Wall"] = "wall";
  StructureKind2["Shelter"] = "shelter";
  StructureKind2["Forge"] = "forge";
  StructureKind2["Trap"] = "trap";
  StructureKind2["FeedBerry"] = "feed_berry";
  StructureKind2["FeedMeat"] = "feed_meat";
  return StructureKind2;
})(StructureKind || {});
var STRUCTURES = {
  ["campfire" /* Campfire */]: {
    kind: "campfire" /* Campfire */,
    name: "Campfire",
    maxHp: 60,
    warmthRadius: 5,
    claimRadius: 10,
    cooks: true,
    blocksMovement: false,
    icon: "\u{1F525}"
  },
  ["wall" /* Wall */]: {
    kind: "wall" /* Wall */,
    name: "Wooden Wall",
    maxHp: 120,
    blocksMovement: true,
    icon: "\u{1F9F1}"
  },
  ["shelter" /* Shelter */]: {
    kind: "shelter" /* Shelter */,
    name: "Shelter",
    maxHp: 200,
    warmthRadius: 3,
    blocksMovement: false,
    icon: "\u{1F6D6}"
  },
  ["forge" /* Forge */]: {
    kind: "forge" /* Forge */,
    name: "Forge",
    maxHp: 150,
    warmthRadius: 2,
    smelts: true,
    blocksMovement: false,
    icon: "\u2692\uFE0F"
  },
  ["trap" /* Trap */]: {
    kind: "trap" /* Trap */,
    name: "Snap Trap",
    maxHp: 1,
    trapDamage: 18,
    blocksMovement: false,
    icon: "\u{1FAA4}"
  },
  ["feed_berry" /* FeedBerry */]: {
    kind: "feed_berry" /* FeedBerry */,
    name: "Berry Bait",
    maxHp: 1,
    bait: "deer",
    blocksMovement: false,
    icon: "\u{1FAD0}"
  },
  ["feed_meat" /* FeedMeat */]: {
    kind: "feed_meat" /* FeedMeat */,
    name: "Meat Bait",
    maxHp: 1,
    bait: "wolf",
    blocksMovement: false,
    icon: "\u{1F969}"
  }
};
var ResourceKind = /* @__PURE__ */ ((ResourceKind2) => {
  ResourceKind2["Tree"] = "tree";
  ResourceKind2["Rock"] = "rock";
  ResourceKind2["Bush"] = "bush";
  ResourceKind2["Grass"] = "grass";
  ResourceKind2["IronVein"] = "iron_vein";
  return ResourceKind2;
})(ResourceKind || {});
var RESOURCES = {
  ["tree" /* Tree */]: {
    kind: "tree" /* Tree */,
    name: "Tree",
    maxAmount: 5,
    action: "chop",
    regrowSec: 45,
    yields: "wood" /* Wood */,
    icon: "\u{1F332}"
  },
  ["rock" /* Rock */]: {
    kind: "rock" /* Rock */,
    name: "Rock",
    maxAmount: 5,
    action: "mine",
    regrowSec: 60,
    yields: "stone" /* Stone */,
    icon: "\u{1FAA8}"
  },
  ["bush" /* Bush */]: {
    kind: "bush" /* Bush */,
    name: "Berry Bush",
    maxAmount: 3,
    action: "forage",
    regrowSec: 30,
    yields: "berry" /* Berry */,
    icon: "\u{1F333}"
  },
  ["grass" /* Grass */]: {
    kind: "grass" /* Grass */,
    name: "Tall Grass",
    maxAmount: 3,
    action: "forage",
    regrowSec: 25,
    yields: "fiber" /* Fiber */,
    icon: "\u{1F33E}"
  },
  ["iron_vein" /* IronVein */]: {
    kind: "iron_vein" /* IronVein */,
    name: "Iron Vein",
    maxAmount: 4,
    action: "mine",
    regrowSec: 90,
    yields: "iron_ore" /* IronOre */,
    icon: "\u26F0\uFE0F"
  }
};

// src/constants/skills.ts
var Skill = /* @__PURE__ */ ((Skill2) => {
  Skill2["Gathering"] = "gathering";
  Skill2["Crafting"] = "crafting";
  Skill2["Combat"] = "combat";
  return Skill2;
})(Skill || {});
function xpForNextLevel(level) {
  return Math.floor(50 * Math.pow(level, 1.5));
}
function levelFromXp(xp, maxLevel = 30) {
  let level = 1;
  let remaining = xp;
  while (level < maxLevel && remaining >= xpForNextLevel(level)) {
    remaining -= xpForNextLevel(level);
    level++;
  }
  return level;
}

// src/constants/recipes.ts
var RECIPES = [
  {
    id: "axe",
    name: "Hatchet",
    inputs: [{ item: "wood" /* Wood */, qty: 3 }, { item: "stone" /* Stone */, qty: 2 }],
    outputItem: "axe" /* Axe */,
    outputQty: 1,
    craftSec: 2,
    icon: "\u{1FA93}"
  },
  {
    id: "pickaxe",
    name: "Pickaxe",
    inputs: [{ item: "wood" /* Wood */, qty: 3 }, { item: "stone" /* Stone */, qty: 3 }],
    outputItem: "pickaxe" /* Pickaxe */,
    outputQty: 1,
    craftSec: 2,
    icon: "\u26CF\uFE0F"
  },
  {
    id: "torch",
    name: "Torch",
    inputs: [{ item: "wood" /* Wood */, qty: 1 }, { item: "fiber" /* Fiber */, qty: 2 }],
    outputItem: "torch" /* Torch */,
    outputQty: 1,
    craftSec: 1,
    icon: "\u{1F526}"
  },
  {
    id: "bow",
    name: "Hunting Bow",
    inputs: [{ item: "wood" /* Wood */, qty: 3 }, { item: "fiber" /* Fiber */, qty: 4 }],
    outputItem: "bow" /* Bow */,
    outputQty: 1,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 2,
    craftSec: 2,
    icon: "\u{1F3F9}"
  },
  {
    id: "arrows",
    name: "Arrows \xD75",
    inputs: [{ item: "wood" /* Wood */, qty: 2 }, { item: "stone" /* Stone */, qty: 1 }],
    outputItem: "arrow" /* Arrow */,
    outputQty: 5,
    craftSec: 1,
    icon: "\u{1FAB6}"
  },
  {
    id: "trap",
    name: "Snap Trap",
    inputs: [{ item: "wood" /* Wood */, qty: 3 }, { item: "stone" /* Stone */, qty: 2 }, { item: "fiber" /* Fiber */, qty: 2 }],
    outputStructure: "trap" /* Trap */,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 3,
    craftSec: 2,
    icon: "\u{1FAA4}"
  },
  {
    id: "campfire",
    name: "Campfire",
    inputs: [{ item: "wood" /* Wood */, qty: 5 }, { item: "stone" /* Stone */, qty: 3 }],
    outputStructure: "campfire" /* Campfire */,
    craftSec: 2,
    icon: "\u{1F525}"
  },
  {
    id: "wall",
    name: "Wooden Wall",
    inputs: [{ item: "wood" /* Wood */, qty: 4 }],
    outputStructure: "wall" /* Wall */,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 2,
    craftSec: 1,
    icon: "\u{1F9F1}"
  },
  {
    id: "shelter",
    name: "Shelter",
    inputs: [{ item: "wood" /* Wood */, qty: 12 }, { item: "fiber" /* Fiber */, qty: 6 }],
    outputStructure: "shelter" /* Shelter */,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 4,
    craftSec: 4,
    icon: "\u{1F6D6}"
  },
  {
    id: "cook_meat",
    name: "Cook Meat",
    inputs: [{ item: "raw_meat" /* RawMeat */, qty: 1 }],
    outputItem: "cooked_meat" /* CookedMeat */,
    outputQty: 1,
    craftSec: 3,
    nearFire: true,
    icon: "\u{1F356}"
  },
  // --- tier 2: iron (mine veins → smelt at a Forge → metal gear) ---
  {
    id: "forge",
    name: "Forge",
    inputs: [{ item: "stone" /* Stone */, qty: 8 }, { item: "wood" /* Wood */, qty: 4 }],
    outputStructure: "forge" /* Forge */,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 3,
    craftSec: 3,
    icon: "\u2692\uFE0F"
  },
  {
    id: "smelt_iron",
    name: "Smelt Iron",
    inputs: [{ item: "iron_ore" /* IronOre */, qty: 1 }, { item: "wood" /* Wood */, qty: 1 }],
    outputItem: "iron_ingot" /* IronIngot */,
    outputQty: 1,
    craftSec: 3,
    nearForge: true,
    icon: "\u{1F529}"
  },
  {
    id: "iron_axe",
    name: "Iron Hatchet",
    // consumes your Hatchet — an upgrade in place, not a second axe to carry
    inputs: [{ item: "axe" /* Axe */, qty: 1 }, { item: "iron_ingot" /* IronIngot */, qty: 2 }, { item: "wood" /* Wood */, qty: 2 }],
    outputItem: "iron_axe" /* IronAxe */,
    outputQty: 1,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 4,
    craftSec: 3,
    icon: "\u{1FA93}"
  },
  {
    id: "iron_pickaxe",
    name: "Iron Pickaxe",
    // consumes your Pickaxe — an upgrade in place, not a second pick to carry
    inputs: [{ item: "pickaxe" /* Pickaxe */, qty: 1 }, { item: "iron_ingot" /* IronIngot */, qty: 2 }, { item: "wood" /* Wood */, qty: 2 }],
    outputItem: "iron_pickaxe" /* IronPickaxe */,
    outputQty: 1,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 4,
    craftSec: 3,
    icon: "\u26CF\uFE0F"
  },
  {
    id: "iron_sword",
    name: "Iron Sword",
    inputs: [{ item: "iron_ingot" /* IronIngot */, qty: 3 }, { item: "wood" /* Wood */, qty: 1 }],
    outputItem: "iron_sword" /* IronSword */,
    outputQty: 1,
    reqSkill: "combat" /* Combat */,
    reqLevel: 3,
    craftSec: 4,
    icon: "\u{1F5E1}\uFE0F"
  },
  {
    id: "iron_armor",
    name: "Iron Armor",
    inputs: [{ item: "iron_ingot" /* IronIngot */, qty: 5 }, { item: "fiber" /* Fiber */, qty: 4 }],
    outputItem: "iron_armor" /* IronArmor */,
    outputQty: 1,
    reqSkill: "crafting" /* Crafting */,
    reqLevel: 5,
    craftSec: 5,
    icon: "\u{1F6E1}\uFE0F"
  }
];
var RECIPES_BY_ID = Object.fromEntries(
  RECIPES.map((r) => [r.id, r])
);

// src/constants/quests.ts
var QuestGoal = /* @__PURE__ */ ((QuestGoal2) => {
  QuestGoal2["BuildCampfire"] = "build_campfire";
  QuestGoal2["CraftTool"] = "craft_tool";
  QuestGoal2["HuntDeer"] = "hunt_deer";
  QuestGoal2["BanishWraith"] = "banish_wraith";
  QuestGoal2["BuildWall"] = "build_wall";
  return QuestGoal2;
})(QuestGoal || {});
var QUEST_CHAIN = [
  {
    title: "Light the Dark",
    desc: "Craft and place a Campfire to push back the night.",
    goal: "build_campfire" /* BuildCampfire */,
    count: 1,
    rewardXp: [{ skill: "crafting" /* Crafting */, amount: 30 }],
    rewardItems: [{ item: "torch" /* Torch */, qty: 2 }]
  },
  {
    title: "Tools of Survival",
    desc: "Craft 2 tools (Hatchet, Pickaxe or Torch) to work the land.",
    goal: "craft_tool" /* CraftTool */,
    count: 2,
    rewardXp: [{ skill: "crafting" /* Crafting */, amount: 40 }],
    rewardItems: [
      { item: "wood" /* Wood */, qty: 6 },
      { item: "stone" /* Stone */, qty: 4 }
    ]
  },
  {
    title: "The Hunt",
    desc: "Hunt 3 deer to feed yourself through the long nights.",
    goal: "hunt_deer" /* HuntDeer */,
    count: 3,
    rewardXp: [{ skill: "combat" /* Combat */, amount: 50 }],
    rewardItems: [{ item: "cooked_meat" /* CookedMeat */, qty: 3 }]
  },
  {
    title: "Hold the Line",
    desc: "Banish 5 wraiths when the dark comes for you.",
    goal: "banish_wraith" /* BanishWraith */,
    count: 5,
    rewardXp: [{ skill: "combat" /* Combat */, amount: 80 }],
    rewardItems: [{ item: "fiber" /* Fiber */, qty: 8 }]
  },
  {
    title: "Fortify the Hollow",
    desc: "Build 3 Walls to defend your fire from the wraiths.",
    goal: "build_wall" /* BuildWall */,
    count: 3,
    rewardXp: [
      { skill: "crafting" /* Crafting */, amount: 60 },
      { skill: "gathering" /* Gathering */, amount: 40 }
    ],
    rewardItems: [{ item: "stone" /* Stone */, qty: 10 }]
  }
];
var CHAIN_LENGTH = QUEST_CHAIN.length;

// src/constants/support.ts
var TICKET_TYPES = ["BUG", "CR"];
var TICKET_STATUSES = ["NEW", "QUEUED", "SAVED", "VOIDED", "RESOLVED"];
var TICKET_TYPE_LABEL = {
  BUG: "Bug report",
  CR: "Change request"
};
var TICKET_STATUS_LABEL = {
  NEW: "New",
  QUEUED: "Queued",
  SAVED: "Saved",
  VOIDED: "Voided",
  RESOLVED: "Resolved"
};
var TICKET_TITLE_MAX = 80;
var TICKET_BODY_MAX = 2e3;

// src/iso.ts
function tileToScreen(tx, ty) {
  return {
    x: (tx - ty) * (TILE_W / 2),
    y: (tx + ty) * (TILE_H / 2)
  };
}
function screenToTile(sx, sy) {
  const a = sx / (TILE_W / 2);
  const b = sy / (TILE_H / 2);
  return {
    tx: (a + b) / 2,
    ty: (b - a) / 2
  };
}
function isoDepth(tx, ty) {
  return (tx + ty) * 1e3;
}
function dist(ax, ay, bx, by) {
  return Math.hypot(ax - bx, ay - by);
}

// src/protocol.ts
var ClientMessage = /* @__PURE__ */ ((ClientMessage2) => {
  ClientMessage2["Move"] = "move";
  ClientMessage2["Gather"] = "gather";
  ClientMessage2["Craft"] = "craft";
  ClientMessage2["Place"] = "place";
  ClientMessage2["PlaceFood"] = "place_food";
  ClientMessage2["Eat"] = "eat";
  ClientMessage2["Attack"] = "attack";
  ClientMessage2["Chat"] = "chat";
  ClientMessage2["Interact"] = "interact";
  ClientMessage2["Respawn"] = "respawn";
  return ClientMessage2;
})(ClientMessage || {});
var ServerMessage = /* @__PURE__ */ ((ServerMessage2) => {
  ServerMessage2["Welcome"] = "welcome";
  ServerMessage2["Chat"] = "chat";
  ServerMessage2["Toast"] = "toast";
  ServerMessage2["Quest"] = "quest";
  ServerMessage2["Died"] = "died";
  ServerMessage2["LevelUp"] = "levelup";
  ServerMessage2["Shot"] = "shot";
  return ServerMessage2;
})(ServerMessage || {});

// src/schema/state.ts
import { Schema, MapSchema, ArraySchema, type, view } from "@colyseus/schema";
var InventorySlot = class extends Schema {
  constructor() {
    super(...arguments);
    this.item = "";
    this.qty = 0;
  }
};
__decorateClass([
  type("string")
], InventorySlot.prototype, "item", 2);
__decorateClass([
  type("uint16")
], InventorySlot.prototype, "qty", 2);
var SkillState = class extends Schema {
  constructor() {
    super(...arguments);
    this.gatheringXp = 0;
    this.craftingXp = 0;
    this.combatXp = 0;
  }
};
__decorateClass([
  type("uint32")
], SkillState.prototype, "gatheringXp", 2);
__decorateClass([
  type("uint32")
], SkillState.prototype, "craftingXp", 2);
__decorateClass([
  type("uint32")
], SkillState.prototype, "combatXp", 2);
var Player = class extends Schema {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.look = "ranger";
    this.x = 0;
    this.y = 0;
    this.dir = 0;
    this.moving = false;
    this.hp = 100;
    this.hunger = 100;
    this.warmth = 100;
    this.stamina = 100;
    this.dead = false;
    this.action = "";
    this.actionPct = 0;
    this.skills = new SkillState();
    this.inventory = new ArraySchema();
    this.questId = "";
    this.questState = "";
    this.questStep = 0;
    this.questProgress = 0;
  }
  // counter toward the current step's goal
};
__decorateClass([
  type("string")
], Player.prototype, "id", 2);
__decorateClass([
  type("string")
], Player.prototype, "name", 2);
__decorateClass([
  type("string")
], Player.prototype, "look", 2);
__decorateClass([
  type("number")
], Player.prototype, "x", 2);
__decorateClass([
  type("number")
], Player.prototype, "y", 2);
__decorateClass([
  type("int8")
], Player.prototype, "dir", 2);
__decorateClass([
  type("boolean")
], Player.prototype, "moving", 2);
__decorateClass([
  type("number")
], Player.prototype, "hp", 2);
__decorateClass([
  type("number")
], Player.prototype, "hunger", 2);
__decorateClass([
  type("number")
], Player.prototype, "warmth", 2);
__decorateClass([
  type("number")
], Player.prototype, "stamina", 2);
__decorateClass([
  type("boolean")
], Player.prototype, "dead", 2);
__decorateClass([
  type("string")
], Player.prototype, "action", 2);
__decorateClass([
  type("uint8")
], Player.prototype, "actionPct", 2);
__decorateClass([
  type(SkillState)
], Player.prototype, "skills", 2);
__decorateClass([
  type([InventorySlot])
], Player.prototype, "inventory", 2);
__decorateClass([
  type("string")
], Player.prototype, "questId", 2);
__decorateClass([
  type("string")
], Player.prototype, "questState", 2);
__decorateClass([
  type("uint8")
], Player.prototype, "questStep", 2);
__decorateClass([
  type("uint16")
], Player.prototype, "questProgress", 2);
var Npc = class extends Schema {
  constructor() {
    super(...arguments);
    this.id = "";
    this.kind = "";
    this.x = 0;
    this.y = 0;
    this.dir = 0;
    this.hp = 10;
    this.maxHp = 10;
    this.behavior = "";
    this.hostile = false;
    this.ownerId = "";
  }
};
__decorateClass([
  type("string")
], Npc.prototype, "id", 2);
__decorateClass([
  type("string")
], Npc.prototype, "kind", 2);
__decorateClass([
  type("number")
], Npc.prototype, "x", 2);
__decorateClass([
  type("number")
], Npc.prototype, "y", 2);
__decorateClass([
  type("int8")
], Npc.prototype, "dir", 2);
__decorateClass([
  type("uint16")
], Npc.prototype, "hp", 2);
__decorateClass([
  type("uint16")
], Npc.prototype, "maxHp", 2);
__decorateClass([
  type("string")
], Npc.prototype, "behavior", 2);
__decorateClass([
  type("boolean")
], Npc.prototype, "hostile", 2);
__decorateClass([
  type("string")
], Npc.prototype, "ownerId", 2);
var ResourceNode = class extends Schema {
  constructor() {
    super(...arguments);
    this.id = "";
    this.kind = "";
    this.x = 0;
    this.y = 0;
    this.amount = 0;
  }
};
__decorateClass([
  type("string")
], ResourceNode.prototype, "id", 2);
__decorateClass([
  type("string")
], ResourceNode.prototype, "kind", 2);
__decorateClass([
  type("number")
], ResourceNode.prototype, "x", 2);
__decorateClass([
  type("number")
], ResourceNode.prototype, "y", 2);
__decorateClass([
  type("uint8")
], ResourceNode.prototype, "amount", 2);
var Structure = class extends Schema {
  constructor() {
    super(...arguments);
    this.id = "";
    this.kind = "";
    this.x = 0;
    this.y = 0;
    this.ownerId = "";
    this.hp = 0;
    this.maxHp = 0;
  }
};
__decorateClass([
  type("string")
], Structure.prototype, "id", 2);
__decorateClass([
  type("string")
], Structure.prototype, "kind", 2);
__decorateClass([
  type("number")
], Structure.prototype, "x", 2);
__decorateClass([
  type("number")
], Structure.prototype, "y", 2);
__decorateClass([
  type("string")
], Structure.prototype, "ownerId", 2);
__decorateClass([
  type("uint16")
], Structure.prototype, "hp", 2);
__decorateClass([
  type("uint16")
], Structure.prototype, "maxHp", 2);
var WorldState = class extends Schema {
  constructor() {
    super(...arguments);
    this.players = new MapSchema();
    this.npcs = new MapSchema();
    this.resources = new MapSchema();
    this.structures = new MapSchema();
    this.timeOfDay = 0.25;
    this.dayCount = 1;
    this.bloodMoon = false;
  }
  // a dangerous boss night
};
__decorateClass([
  view(),
  type({ map: Player })
], WorldState.prototype, "players", 2);
__decorateClass([
  view(),
  type({ map: Npc })
], WorldState.prototype, "npcs", 2);
__decorateClass([
  view(),
  type({ map: ResourceNode })
], WorldState.prototype, "resources", 2);
__decorateClass([
  view(),
  type({ map: Structure })
], WorldState.prototype, "structures", 2);
__decorateClass([
  type("number")
], WorldState.prototype, "timeOfDay", 2);
__decorateClass([
  type("uint32")
], WorldState.prototype, "dayCount", 2);
__decorateClass([
  type("boolean")
], WorldState.prototype, "bloodMoon", 2);
export {
  AOI_RADIUS,
  BIOMES,
  BUILD_RANGE,
  Biome,
  CHAIN_LENGTH,
  ClientMessage,
  DAY_LENGTH_SEC,
  ITEMS,
  InventorySlot,
  ItemId,
  NIGHT_END,
  NIGHT_START,
  Npc,
  PLAYER_SPEED,
  Player,
  QUEST_CHAIN,
  QuestGoal,
  RECIPES,
  RECIPES_BY_ID,
  RESOURCES,
  ResourceKind,
  ResourceNode,
  STRUCTURES,
  ServerMessage,
  Skill,
  SkillState,
  Structure,
  StructureKind,
  TICKET_BODY_MAX,
  TICKET_STATUSES,
  TICKET_STATUS_LABEL,
  TICKET_TITLE_MAX,
  TICKET_TYPES,
  TICKET_TYPE_LABEL,
  TICK_MS,
  TICK_RATE,
  TILE_H,
  TILE_W,
  WORLD_H,
  WORLD_W,
  WorldState,
  bestArmorDefense,
  bestRanged,
  bestWeaponDamage,
  biomeAt,
  darkness,
  dist,
  isNight,
  isoDepth,
  levelFromXp,
  ownsEqualOrBetter,
  screenToTile,
  tileToScreen,
  toolPowerFor,
  xpForNextLevel
};
//# sourceMappingURL=index.js.map